// import {
//   Video,
//   Play,
//   Activity,
//   Car,
//   CheckCircle,
//   Layers,
//   Camera,
//   ArrowRight,
// } from "lucide-react";
// import { useEffect, useRef, useState } from "react";

// const VideoDatasetServices = () => {
//   const observerRefs = useRef([]);
//   const [visibleElements, setVisibleElements] = useState(new Set());

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setVisibleElements((prev) => new Set([...prev, entry.target]));
//           }
//         });
//       },
//       { threshold: 0.1, rootMargin: "50px" }
//     );

//     observerRefs.current.forEach((ref) => {
//       if (ref) observer.observe(ref);
//     });

//     return () => observer.disconnect();
//   }, []);

//   const addToRefs = (el) => {
//     if (el && !observerRefs.current.includes(el)) {
//       observerRefs.current.push(el);
//     }
//   };

//   const types = [
//     {
//       icon: Activity,
//       title: "Action Recognition",
//       description: "Human movement & gesture datasets for detection models.",
//     },
//     {
//       icon: Play,
//       title: "Event Detection",
//       description: "Temporal event-based classification datasets.",
//     },
//     {
//       icon: Video,
//       title: "Security Footage",
//       description: "Surveillance video datasets for anomaly detection.",
//     },
//     {
//       icon: Car,
//       title: "Autonomous Driving",
//       description: "Traffic & road scene datasets for self-driving AI.",
//     },
//   ];

//   const industries = [
//     "Autonomous Vehicles",
//     "Sports Analytics",
//     "Security & Surveillance",
//     "Entertainment & Media",
//     "Healthcare Monitoring",
//     "Retail Analytics",
//   ];

//   const benefits = [
//     "High-resolution video datasets",
//     "Frame-accurate annotations",
//     "Multi-object & multi-label tagging",
//     "Supports real-time inference training",
//     "Large-scale sequence datasets",
//     "Perfect for action/gesture AI models",
//   ];

//   const extraFeatures = [
//     "Multi-camera datasets",
//     "Low-light and infrared footage",
//     "High FPS slow-motion datasets",
//     "Drone and aerial video footage",
//   ];

//   return (
//     <div className="min-h-screen bg-white">
//       <style>{`
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes scaleIn {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .animate-on-scroll {
//           opacity: 0;
//         }

//         .animate-on-scroll.visible {
//           animation: fadeInUp 0.6s ease-out forwards;
//         }

//         .animate-scale {
//           opacity: 0;
//         }

//         .animate-scale.visible {
//           animation: scaleIn 0.5s ease-out forwards;
//         }

//         .hero-title {
//           animation: fadeInUp 0.8s ease-out forwards;
//         }

//         .hero-subtitle {
//           animation: fadeInUp 0.8s 0.2s ease-out backwards;
//         }

//         .hero-cta {
//           animation: fadeInUp 0.8s 0.4s ease-out backwards;
//         }

//         .stagger-1 { animation-delay: 0.1s; }
//         .stagger-2 { animation-delay: 0.2s; }
//         .stagger-3 { animation-delay: 0.3s; }
//         .stagger-4 { animation-delay: 0.4s; }
//         .stagger-5 { animation-delay: 0.5s; }
//         .stagger-6 { animation-delay: 0.6s; }
//       `}</style>

//       {/* HERO SECTION */}
//       <section className="relative h-[500px] overflow-hidden bg-slate-900">
//         {/* Background Image */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1920&q=80')",
//           }}
//         />

//         {/* Dark ecommerce-style overlay */}
//         <div className="absolute inset-0 bg-black/75" />

//         <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
//           <div className="text-white max-w-3xl">
//             {/* MATCHED TITLE SIZE */}
//             <h1 className="text-4xl sm:text-5xl font-light mb-4 tracking-tight">
//               Video Dataset Services
//             </h1>

//             {/* MATCHED PARAGRAPH SIZE */}
//             <p className="text-lg mb-6 text-slate-300 font-light max-w-2xl">
//               High-quality video datasets for computer vision, object tracking,
//               action recognition, and real-time AI systems.
//             </p>

//             {/* MATCHED BUTTON */}
//             <button className="inline-flex items-center gap-2 bg-white text-slate-900 px-7 py-3 rounded-md font-medium hover:bg-slate-100 transition-colors">
//               Explore Video Data
//               <ArrowRight className="w-4 h-4" />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* WHY VIDEO DATA MATTERS */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-6xl mx-auto">
//           <div
//             ref={addToRefs}
//             className={`text-center mb-16 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[0]) ? "visible" : ""
//             }`}
//           >
//             <h2 className="text-4xl font-light mb-6 text-slate-900">
//               Why Video Datasets Matter
//             </h2>
//             <p className="text-lg text-slate-600 max-w-3xl mx-auto font-light">
//               Video datasets provide temporal, motion-rich information that is
//               essential for advanced AI systems such as action recognition,
//               autonomous navigation, surveillance analytics, and human activity
//               detection.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             {benefits.map((benefit, index) => (
//               <div
//                 key={index}
//                 ref={addToRefs}
//                 className={`p-8 bg-white border border-slate-200 hover:border-slate-300 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[index + 1])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <CheckCircle className="w-6 h-6 mb-4 text-slate-700" />
//                 <p className="text-slate-800 font-light">{benefit}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* TYPES OF VIDEO DATASETS */}
//       <section className="py-24 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 text-slate-900 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[7]) ? "visible" : ""
//             }`}
//           >
//             Types of Video Datasets
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {types.map((type, index) => (
//               <div
//                 key={type.title}
//                 ref={addToRefs}
//                 className={`p-8 bg-slate-900 text-white hover:bg-slate-800 transition-colors animate-scale stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[8 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <type.icon className="w-8 h-8 mb-4" />
//                 <h3 className="text-xl font-medium mb-3">{type.title}</h3>
//                 <p className="text-slate-300 font-light text-sm leading-relaxed">
//                   {type.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* EXTRA FEATURES */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-6xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 text-slate-900 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[12]) ? "visible" : ""
//             }`}
//           >
//             Additional Dataset Features
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {extraFeatures.map((feat, index) => (
//               <div
//                 key={feat}
//                 ref={addToRefs}
//                 className={`p-8 bg-white border border-slate-200 hover:border-slate-300 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[13 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <Layers className="w-6 h-6 mb-4 text-slate-700" />
//                 <h3 className="text-lg font-medium text-slate-900">{feat}</h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* FRAME BY FRAME ANNOTATION */}
//       <section className="py-24 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div
//             ref={addToRefs}
//             className={`text-center mb-16 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[17]) ? "visible" : ""
//             }`}
//           >
//             <h2 className="text-4xl font-light mb-6 text-slate-900">
//               Frame-by-Frame Annotation
//             </h2>
//             <p className="text-slate-600 text-lg max-w-3xl mx-auto font-light">
//               Accurate temporal annotations such as object tracking, activity
//               boundaries, motion analysis, scene transitions and multi-class
//               labeling.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             {[
//               "Object Tracking",
//               "Temporal Segmentation",
//               "Scene Classification",
//             ].map((item, index) => (
//               <div
//                 key={item}
//                 ref={addToRefs}
//                 className={`p-8 bg-slate-900 text-white text-center animate-scale stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[18 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <h3 className="text-lg font-medium">{item}</h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INDUSTRIES */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-7xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 text-slate-900 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[21]) ? "visible" : ""
//             }`}
//           >
//             Industries Using Video AI
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {industries.map((industry, index) => (
//               <div
//                 key={industry}
//                 ref={addToRefs}
//                 className={`p-8 bg-white border border-slate-200 hover:border-slate-300 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[22 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <div className="flex items-center gap-3">
//                   <Camera className="w-6 h-6 text-slate-700" />
//                   <h3 className="text-base font-medium text-slate-900">
//                     {industry}
//                   </h3>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* WORKFLOW TIMELINE */}
//       <section className="py-24 px-6 bg-slate-900 text-white">
//         <div className="max-w-5xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[28]) ? "visible" : ""
//             }`}
//           >
//             Our Workflow
//           </h2>

//           <div className="relative">
//             <div className="absolute left-1/2 top-0 bottom-0 w-px bg-slate-700 -translate-x-1/2 hidden md:block"></div>

//             {[
//               "Video Collection",
//               "Frame Extraction",
//               "Annotation & Labeling",
//               "Quality Verification",
//               "Dataset Delivery",
//             ].map((step, index) => (
//               <div
//                 key={step}
//                 ref={addToRefs}
//                 className={`flex items-center mb-12 ${
//                   index % 2 === 0 ? "md:justify-start" : "md:justify-end"
//                 } animate-on-scroll stagger-${index + 1} ${
//                   visibleElements.has(observerRefs.current[29 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <div className="w-full md:w-5/12 p-6 bg-slate-800 border border-slate-700 hover:border-slate-600 transition-colors">
//                   <div className="flex items-center gap-4">
//                     <div className="w-10 h-10 rounded-full bg-white text-slate-900 flex items-center justify-center font-medium text-sm">
//                       {index + 1}
//                     </div>
//                     <p className="text-base font-light">{step}</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-24 bg-white border-t border-slate-200">
//         <div
//           ref={addToRefs}
//           className={`max-w-4xl mx-auto text-center px-6 animate-on-scroll ${
//             visibleElements.has(observerRefs.current[34]) ? "visible" : ""
//           }`}
//         >
//           <h2 className="text-3xl sm:text-4xl font-light mb-8 text-slate-900">
//             Start Your Video AI Project Today
//           </h2>

//           <button className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-3 rounded-sm font-medium hover:bg-slate-800 transition-colors">
//             Get Custom Video Datasets
//             <ArrowRight className="w-4 h-4" />
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default VideoDatasetServices;

import { motion } from "framer-motion";
import {
  Video,
  Play,
  Activity,
  Car,
  CheckCircle2,
  Layers,
  Camera,
  ArrowRight,
  ShieldCheck,
  Zap,
  Timer,
  Maximize,
  Scan,
  Cctv,
  Waves,
  Eye,
  Smartphone
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function VideoDatasetServices() {
  const types = [
    {
      icon: Activity,
      title: "Action Recognition",
      desc: "Temporal movement and gesture datasets for human behavior detection models.",
    },
    {
      icon: Play,
      title: "Event Classification",
      desc: "High-precision temporal boundary labeling for specific event-based triggers.",
    },
    {
      icon: Cctv,
      title: "Surveillance Intelligence",
      desc: "Security-grade footage datasets engineered for anomaly and threat detection.",
    },
    {
      icon: Car,
      title: "Autonomous Mobility",
      desc: "Multi-modal road scene datasets for self-driving and obstacle avoidance AI.",
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        {/* Subtle Motion Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Temporal AI Data
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">Video Data</span>{" "}
              Systems.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              High-fidelity video datasets for object tracking and action
              recognition, engineered for real-time inference and
              mission-critical computer vision.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Explore Video Data <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= CORE CAPABILITIES (REFINED GRID) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16 md:text-left">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Ground Truth
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Temporal Dataset Categories
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {types.map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6">
                  <item.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TECHNICAL DEPTH (DARK ACCENT) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-8 items-stretch">
            <motion.div
              {...fadeUp}
              className="lg:col-span-12 bg-[#0f172a] p-10 md:p-16 rounded-[2.5rem] text-white relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 blur-[100px] rounded-full" />
              <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <Timer className="text-indigo-400 mb-6" size={40} />
                  <h3 className="text-3xl font-bold mb-4 tracking-tight">
                    Frame-By-Frame Engineering
                  </h3>
                  <p className="text-slate-400 text-lg font-light leading-relaxed mb-8">
                    Precision in video AI requires sub-frame temporal accuracy.
                    Our labeling pipelines ensure perfect object tracking across
                    sequential frames with no drift.
                  </p>
                  <div className="grid sm:grid-cols-2 gap-4">
                    {[
                      "Object Trajectories",
                      "Action Boundaries",
                      "Motion Analysis",
                      "Scene Transitions",
                    ].map((item) => (
                      <div
                        key={item}
                        className="flex items-center gap-3 bg-white/5 p-4 rounded-xl border border-white/10 backdrop-blur-sm"
                      >
                        <CheckCircle2
                          size={18}
                          className="text-indigo-400 shrink-0"
                        />
                        <span className="text-sm font-medium text-slate-200">
                          {item}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="hidden lg:block relative h-full">
                  <div className="absolute -inset-10 bg-indigo-500/20 blur-3xl rounded-full" />
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80"
                    alt="Video Analysis"
                    className="rounded-2xl shadow-2xl relative z-10 border border-white/10 opacity-80"
                  />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= INDUSTRIES GRID ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16 text-left">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Industry Deployment
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[
              "Sports Analytics",
              "Retail Tracking",
              "Smart Cities",
              "Healthcare Ops",
              "Robotics",
              "Media Production",
            ].map((industry, i) => (
              <div
                key={i}
                className="px-4 py-6 border border-slate-100 rounded-xl text-center bg-slate-50/50 hover:bg-white hover:shadow-md transition-all"
              >
                <Camera className="mx-auto text-indigo-600 mb-3" size={20} />
                <p className="text-[12px] font-bold text-slate-700 tracking-tight">
                  {industry}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= EXTRA SPECS (INDUSTRIAL GRID) ================= */}
      {/* ================= TECHNICAL STANDARDS & ACQUISITION ================= */}
      <section className="py-24 bg-[#0f172a] text-white relative overflow-hidden border-y border-white/5">
        {/* Subtle grid background for the dark section */}
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "40px 40px",
          }}
        />

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-20 items-start">
            {/* Left Column: Acquisition Logic */}
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
                Data Engineering
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8 tracking-tight">
                Advanced Acquisition <br />
                <span className="text-slate-500">& Performance Standards.</span>
              </h2>

              <div className="grid sm:grid-cols-2 gap-x-8 gap-y-10">
                {[
                  {
                    icon: Waves,
                    t: "Multi-Camera Sync",
                    d: "Precision time-aligned datasets from multiple vantage points for 3D reconstruction.",
                  },
                  {
                    icon: Zap,
                    t: "High-FPS Capture",
                    d: "High-velocity slow-motion data collection for micro-gesture and rapid movement analysis.",
                  },
                  {
                    icon: Eye,
                    t: "Low-Light / IR",
                    d: "Specialized infrared and thermal datasets for zero-lux surveillance AI environments.",
                  },
                  {
                    icon: Smartphone,
                    t: "Edge Optimization",
                    d: "Datasets formatted specifically for real-time mobile and IoT inference models.",
                  },
                ].map((feat, i) => (
                  <div key={i} className="group">
                    <div className="w-10 h-10 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center text-indigo-400 mb-4 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                      <feat.icon size={20} />
                    </div>
                    <h4 className="font-bold text-sm text-slate-100 mb-2">
                      {feat.t}
                    </h4>
                    <p className="text-xs text-slate-400 leading-relaxed font-light">
                      {feat.d}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column: Security & Compliance Matrix */}
            <div className="bg-white/5 border border-white/10 rounded-[2.5rem] p-8 md:p-12 backdrop-blur-sm relative">
              <div className="absolute top-0 right-0 p-8">
                <ShieldCheck
                  className="text-indigo-500 opacity-20"
                  size={120}
                  strokeWidth={0.5}
                />
              </div>

              <h3 className="text-xl font-bold mb-8 flex items-center gap-3">
                <ShieldCheck className="text-indigo-400" size={24} />
                Security & Compliance
              </h3>

              <div className="space-y-6">
                {[
                  {
                    label: "Data Integrity",
                    value:
                      "99.9% Accuracy index through multi-pass human verification.",
                  },
                  {
                    label: "Protocol",
                    value:
                      "SOC2 Type II compliant data handling and ingestion tunnels.",
                  },
                  {
                    label: "Anonymization",
                    value:
                      "Automated PII blurring and metadata stripping for privacy.",
                  },
                  {
                    label: "Delivery",
                    value:
                      "Secure encrypted cloud handoff or localized on-prem server sync.",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="border-b border-white/5 pb-4 last:border-0"
                  >
                    <span className="text-[10px] font-black text-indigo-400 uppercase tracking-widest block mb-1">
                      {item.label}
                    </span>
                    <p className="text-sm text-slate-300 font-light leading-relaxed">
                      {item.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-white relative overflow-hidden border-t border-slate-100 text-center">
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight">
            Structure Your Motion Intelligence.
          </h2>
          <p className="text-slate-500 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto text-center">
            Accelerate your video AI cycles with high-resolution, frame-accurate
            datasets tailored to your specific model requirements.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-slate-900 text-white px-10 py-3.5 rounded-xl font-bold text-sm hover:bg-indigo-600 transition-all shadow-xl shadow-black/20"
            >
              Request Video Dataset Proposal
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}